// frontend/src/App.js
import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate, Outlet, useNavigate } from 'react-router-dom';
import Login from './pages/Login';
import Dashboard from './admin/Dashboard';
import ContainerManagement from './admin/ContainerManagement';
import CargoManagement from './admin/CargoManagement';
import CategoryManagement from './admin/CategoryManagement';
import PaymentManagement from './admin/PaymentManagement';
import SMSManagement from './admin/SMSManagement'; 
import BannerManagement from './admin/BannerManagement';
import ClientFeaturesManagement from './admin/ClientFeaturesManagement';
import ClientServicesManagement from './admin/ClientServicesManagement';
import CargoRequestsManagement from './admin/CargoRequestsManagement';
// import NotificationsList from './admin/NotificationsList';
import ContactManagement from './admin/ContactManagement';
import UsersManagement from './admin/UsersManagement';
import Settings from './admin/Settings';

// Client Pages
import HomePage from './pages/client/HomePage';
import TrackingPage from './pages/client/TrackingPage';

import Sidebar from './components/Sidebar';
import TopBar from './components/TopBar1';
import Footer from './components/Footer';

// Client Components
import ClientHeader from './components/client/ClientHeader';
import ClientFooter from './components/client/ClientFooter';

import { AuthProvider, useAuth } from './context/AuthContext';
import ProtectedRoute from './components/ProtectedRoute';

import './styles/admin.css';
import './styles/custom.css';
import './styles/client.css';

export default function App() {
  return (
    <Router>
      <AuthProvider>
        <Routes>
          {/* ==================== CLIENT ROUTES ==================== */}
          <Route path="/" element={<ClientLayout />}>
            <Route index element={<HomePage />} />
            <Route path="tracking" element={<TrackingPage />} />
            <Route path="tracking/:code" element={<TrackingPage />} />
          </Route>

          {/* ==================== ADMIN ROUTES ==================== */}
          <Route path="/login" element={<Login />} />
          <Route path="/admin" element={<ProtectedAdminLayout />}>
            <Route index element={<Navigate to="dashboard" replace />} />
            
            {/* ==================== БҮГД ХАРНА ==================== */}
            <Route path="dashboard" element={<Dashboard />} />
            <Route path="categories" element={<CategoryManagement />} />
            <Route path="banners" element={<BannerManagement />} />
            <Route path="client-features" element={<ClientFeaturesManagement />} />
            <Route path="client-services" element={<ClientServicesManagement />} />
            <Route path="client-contact" element={<ContactManagement />} />
            <Route path="cargo-requests" element={<CargoRequestsManagement />} />
            {/* <Route path="notifications" element={<NotificationsList />} /> */}
            
            
            {/* ==================== ЭРХТЭЙ БОЛ ХАРАГДАНА ==================== */}

            <Route 
              path="settings" 
              element={
                <ProtectedRoute 
                  requiredPermission="settings:manage"
                  showAccessDenied={true}
                >
                  <Settings />
                </ProtectedRoute>
              } 
            />
            
            {/* Чингэлэг - container:view эрхтэй бол */}
            <Route 
              path="containers" 
              element={
                <ProtectedRoute 
                  requiredPermission="container:view"
                  showAccessDenied={true}
                >
                  <ContainerManagement />
                </ProtectedRoute>
              } 
            />
            
            {/* Ачаа - cargo:view эсвэл cargo:create эрхтэй бол */}
            <Route 
              path="cargo" 
              element={
                <ProtectedRoute 
                  requiredPermissions={["cargo:view", "cargo:create"]}
                  requireAll={false}
                  showAccessDenied={true}
                >
                  <CargoManagement />
                </ProtectedRoute>
              } 
            />
            
            {/* Төлбөр - payment:view эсвэл payment:view-all эрхтэй бол */}
            <Route 
              path="payment" 
              element={
                <ProtectedRoute 
                  requiredPermissions={["payment:view", "payment:view-all"]}
                  requireAll={false}
                  showAccessDenied={true}
                >
                  <PaymentManagement />
                </ProtectedRoute>
              } 
            />
            
            {/* SMS - sms:view эрхтэй бол */}
            <Route 
              path="sms" 
              element={
                <ProtectedRoute 
                  requiredPermission="sms:view"
                  showAccessDenied={true}
                >
                  <SMSManagement />
                </ProtectedRoute>
              } 
            />
            
            {/* Хэрэглэгч - users:view эрхтэй бол */}
            <Route 
              path="users" 
              element={
                <ProtectedRoute 
                  requiredPermission="users:view"
                  showAccessDenied={true}
                >
                  <UsersManagement />
                </ProtectedRoute>
              } 
            />
          </Route>
          
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </AuthProvider>
    </Router>
  );
}

// Client Layout
function ClientLayout() {
  return (
    <div className="client-layout">
      <ClientHeader />
      <main className="client-main">
        <Outlet />
      </main>
      <ClientFooter />
    </div>
  );
}

// Protected Admin Layout
function ProtectedAdminLayout() {
  const { user, loading } = useAuth();
  const [sidebarOpen, setSidebarOpen] = React.useState(false);

  if (loading) {
    return (
      <div className="flex items-center justify-center min-h-screen bg-gray-100">
        <div className="text-center">
          <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-600 mx-auto mb-4"></div>
          <p className="text-gray-600">Ачааллаж байна...</p>
        </div>
      </div>
    );
  }

  if (!user || !['system_admin', 'staff'].includes(user.role)) {
    return <Navigate to="/login" replace />;
  }

  return (
    <div className="admin-layout">
      <TopBar toggleSidebar={() => setSidebarOpen(!sidebarOpen)} />
      <div className="admin-container">
        <Sidebar isOpen={sidebarOpen} onClose={() => setSidebarOpen(false)} />
        <div className="admin-main">
          <Outlet />
        </div>
      </div>
      <Footer />
    </div>
  );
}

// Coming Soon компонент
function ComingSoon({ title, icon = '🚧' }) {
  return (
    <div className="flex items-center justify-center min-h-[60vh]">
      <div className="text-center p-8 bg-white rounded-lg shadow-lg max-w-md">
        <div className="text-6xl mb-4">{icon}</div>
        <h1 className="text-2xl md:text-3xl font-bold text-gray-800 mb-4">{title}</h1>
        <p className="text-gray-600 mb-6">
          Энэ модуль одоогоор хөгжүүлэгдэж байна. <br />
          Удахгүй админ панелд нэмэгдэх болно.
        </p>
        <div className="space-y-3 text-left bg-blue-50 p-4 rounded-lg text-sm">
          <p className="flex items-start gap-2">
            <span className="text-blue-600 font-bold">✓</span>
            <span>Backend APIs бэлэн байна</span>
          </p>
          <p className="flex items-start gap-2">
            <span className="text-blue-600 font-bold">✓</span>
            <span>Database tables үүссэн</span>
          </p>
          <p className="flex items-start gap-2">
            <span className="text-orange-500 font-bold">⏳</span>
            <span>Frontend UI хөгжүүлэгдэж байна</span>
          </p>
        </div>
        <div className="mt-6">
          <div className="inline-block px-4 py-2 bg-blue-100 text-blue-700 rounded-lg text-sm font-semibold">
            🚀 Удахгүй бэлэн болно
          </div>
        </div>
      </div>
    </div>
  );
}